/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetActeursResponse,
  GetCompagniesResponse,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetActeursResponseFromJSON,
    GetActeursResponseToJSON,
    GetCompagniesResponseFromJSON,
    GetCompagniesResponseToJSON,
} from '../models/index';

export interface GetAccountingManagerActorsRequest {
    filter?: string;
    skipCount?: number;
    maxResultCount?: number;
}

export interface GetAssociationActorsRequest {
    filter?: string;
    skipCount?: number;
    maxResultCount?: number;
}

export interface GetClaimManagerActorsRequest {
    filter?: string;
    skipCount?: number;
    maxResultCount?: number;
}

export interface GetCompagniesRequest {
    filter?: string;
    skipCount?: number;
    maxResultCount?: number;
}

export interface GetContractManagerActorsRequest {
    filter?: string;
    skipCount?: number;
    maxResultCount?: number;
}

export interface GetInsurerActorsRequest {
    filter?: string;
    skipCount?: number;
    maxResultCount?: number;
}

export interface GetWholesalerActorsRequest {
    filter?: string;
    skipCount?: number;
    maxResultCount?: number;
}

/**
 * 
 */
export class ActorsApi extends runtime.BaseAPI {

    /**
     * Gestionnaires de comptabilité
     */
    async getAccountingManagerActorsRaw(requestParameters: GetAccountingManagerActorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetActeursResponse>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skipCount'] != null) {
            queryParameters['SkipCount'] = requestParameters['skipCount'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['MaxResultCount'] = requestParameters['maxResultCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/liste/gestionnaires-comptabilites`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetActeursResponseFromJSON(jsonValue));
    }

    /**
     * Gestionnaires de comptabilité
     */
    async getAccountingManagerActors(requestParameters: GetAccountingManagerActorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetActeursResponse> {
        const response = await this.getAccountingManagerActorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Associations sélectionnables
     */
    async getAssociationActorsRaw(requestParameters: GetAssociationActorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetActeursResponse>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skipCount'] != null) {
            queryParameters['SkipCount'] = requestParameters['skipCount'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['MaxResultCount'] = requestParameters['maxResultCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/liste/associations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetActeursResponseFromJSON(jsonValue));
    }

    /**
     * Associations sélectionnables
     */
    async getAssociationActors(requestParameters: GetAssociationActorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetActeursResponse> {
        const response = await this.getAssociationActorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gestionnaires de sinistres
     */
    async getClaimManagerActorsRaw(requestParameters: GetClaimManagerActorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetActeursResponse>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skipCount'] != null) {
            queryParameters['SkipCount'] = requestParameters['skipCount'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['MaxResultCount'] = requestParameters['maxResultCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/liste/gestionnaires-sinistres`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetActeursResponseFromJSON(jsonValue));
    }

    /**
     * Gestionnaires de sinistres
     */
    async getClaimManagerActors(requestParameters: GetClaimManagerActorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetActeursResponse> {
        const response = await this.getClaimManagerActorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Compagnies porteurs de risque sélectionnables
     */
    async getCompagniesRaw(requestParameters: GetCompagniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompagniesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skipCount'] != null) {
            queryParameters['SkipCount'] = requestParameters['skipCount'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['MaxResultCount'] = requestParameters['maxResultCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/liste/compagnies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompagniesResponseFromJSON(jsonValue));
    }

    /**
     * Compagnies porteurs de risque sélectionnables
     */
    async getCompagnies(requestParameters: GetCompagniesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompagniesResponse> {
        const response = await this.getCompagniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gestionnaires de contrats
     */
    async getContractManagerActorsRaw(requestParameters: GetContractManagerActorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetActeursResponse>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skipCount'] != null) {
            queryParameters['SkipCount'] = requestParameters['skipCount'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['MaxResultCount'] = requestParameters['maxResultCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/liste/gestionnaires-contrats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetActeursResponseFromJSON(jsonValue));
    }

    /**
     * Gestionnaires de contrats
     */
    async getContractManagerActors(requestParameters: GetContractManagerActorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetActeursResponse> {
        const response = await this.getContractManagerActorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assureurs sélectionnables
     */
    async getInsurerActorsRaw(requestParameters: GetInsurerActorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetActeursResponse>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skipCount'] != null) {
            queryParameters['SkipCount'] = requestParameters['skipCount'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['MaxResultCount'] = requestParameters['maxResultCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/liste/assureurs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetActeursResponseFromJSON(jsonValue));
    }

    /**
     * Assureurs sélectionnables
     */
    async getInsurerActors(requestParameters: GetInsurerActorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetActeursResponse> {
        const response = await this.getInsurerActorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Grossistes sélectionnables
     */
    async getWholesalerActorsRaw(requestParameters: GetWholesalerActorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetActeursResponse>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skipCount'] != null) {
            queryParameters['SkipCount'] = requestParameters['skipCount'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['MaxResultCount'] = requestParameters['maxResultCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/liste/grossistes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetActeursResponseFromJSON(jsonValue));
    }

    /**
     * Grossistes sélectionnables
     */
    async getWholesalerActors(requestParameters: GetWholesalerActorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetActeursResponse> {
        const response = await this.getWholesalerActorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
